import { AUTOFACET_CLEAR_ALL, AUTOFACET_REMOVE_FILTER, AUTOFACET_RESET } from 'constants/reduxActions';
import type { BreadcrumbType } from 'types/search';

export function removeAutofacetFilter(breadcrumb: BreadcrumbType) {
  return {
    type: AUTOFACET_REMOVE_FILTER,
    breadcrumb
  } as const;
}

export function clearAllAutofacets(breadcrumbs: BreadcrumbType[]) {
  return {
    type: AUTOFACET_CLEAR_ALL,
    breadcrumbs
  } as const;
}

export function resetAutofacet() {
  return {
    type: AUTOFACET_RESET
  } as const;
}
